const HeaderLoaded = (data: any) => ({ type: 'HEADER_LOADED', payload: data });
const AlertLoaded = (data: any) => ({ type: 'ALERT_LOADED', payload: data });
const StoriesLoaded = (data: any) => ({ type: 'STORIES_LOADED', payload: data });
const CalculatorLoaded = (data: any) => ({ type: 'CALCULATOR_LOADED', payload: data });
const ArticleLoaded = (data: any) => ({ type: 'ARTICLE_LOADED', payload: data });
const VacanciesLoaded = (data: any) => ({ type: 'VACANCIES_LOADED', payload: data });
const WidthWindowLoaded = (data: any) => ({ type: 'WIDTH_WINDOW_LOADED', payload: data });
const OffsetContentLoaded = (data: any) => ({ type: 'OFFSET_CONTENT_LOADED', payload: data });
const BlogLoaded = (data: any) => ({ type: 'BLOG_LOADED', payload: data });
const BlogMainLoaded = (data: any) => ({ type: 'BLOG_MAIN_LOADED', payload: data });
const BlogPopularLoaded = (data: any) => ({ type: 'BLOG_POPULAR_LOADED', payload: data });
const LogosPartnersLoaded = (data: any) => ({ type: 'LOGOS_PARTNERS_LOADED', payload: data });
const AdvantagesSliderLoaded = (data: any) => ({ type: 'ADVANTAGES_SLIDER_LOADED', payload: data });
const ReviewsLoaded = (data: any) => ({ type: 'REVIEWS_LOADED', payload: data });
const AboutLoaded = (data: any) => ({ type: 'ABOUT_LOADED', payload: data });
const State404Loaded = (data: any) => ({ type: 'STATE_404_LOADED', payload: data });
const BlockedSendLoaded = (data: any) => ({ type: 'BLOCKED_SEND_LOADED', payload: data });
const RecaptchaV2RefLoaded = (data: any) => ({ type: 'RECAPTCHAV2_LOADED', payload: data });
const TextCardsLoaded = (data: any) => ({ type: 'TEXT_CARDS_LOADED', payload: data });
const IconCardsLoaded = (data: any) => ({ type: 'ICON_CARDS_LOADED', payload: data });
const ContactFormsLoaded = (data: any) => ({ type: 'CONTACT_FORMS_LOADED', payload: data });

export {
  HeaderLoaded,
  AlertLoaded,
  StoriesLoaded,
  CalculatorLoaded,
  ArticleLoaded,
  VacanciesLoaded,
  WidthWindowLoaded,
  OffsetContentLoaded,
  BlogLoaded,
  BlogMainLoaded,
  BlogPopularLoaded,
  LogosPartnersLoaded,
  AdvantagesSliderLoaded,
  ReviewsLoaded,
  AboutLoaded,
  State404Loaded,
  BlockedSendLoaded,
  RecaptchaV2RefLoaded,
  TextCardsLoaded,
  IconCardsLoaded,
  ContactFormsLoaded
};
